import { readFiniteNumber } from "./viewTimeSeries";

export function formatRecoveryPercent(value, fallback = "--") {
  const numericValue = readFiniteNumber(value);
  if (numericValue == null) return fallback;
  return (numericValue * 100).toFixed(0);
}

export function formatRecoveryDuration(value, fallback = "--") {
  const numericValue = readFiniteNumber(value);
  if (numericValue == null) return fallback;

  const totalSeconds = Math.max(0, Math.round(numericValue));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function getBreathingVariabilityAxisMax(maxInterval) {
  const numericValue = readFiniteNumber(maxInterval);
  if (numericValue == null) return 6;
  return Math.max(6, Math.ceil(numericValue + 1));
}
